import classnames from 'classnames/bind';
import { AspectRatioKeeper, Image } from 'taboola-ultimate-ui';
import ThumbnailOverlay from 'modules/campaigns/modules/creative-creator/components/ThumbnailOverlay/ThumbnailOverlay';
import ThumbnailLoading from 'modules/campaigns/modules/creative-creator/components/ThumbnailsField/ThumbnailGallery/ThumbnailLoading/ThumbnailLoading';
import { modifyExternalUrl } from 'modules/campaigns/services/utils';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './uploadedImage.module.scss';

const classNameBuilder = classnames.bind(styles);

export const UploadedImage = ({ imageDataUrl, onCleanMedia }) => {
    const isMotionParamsEnabled = useConfigMatch({
        [FEATURE_FLAGS.IMAGE_TO_MOTION_PARAMS_ENABLED]: 'true',
    });

    const thumbnailOverlayProps = {};
    if (isMotionParamsEnabled) {
        thumbnailOverlayProps.className = styles['thumbnail-overlay'];
    }

    return (
        <div className={classNameBuilder('container', { 'with-motion-params': isMotionParamsEnabled })}>
            {!isMotionParamsEnabled && (
                <div className={styles['upload-header']}>
                    <FormattedMessage
                        id="creative.editor.tab.aiGenerated.imageToMotion.header.uploaded"
                        defaultMessage="Selected image"
                    />
                </div>
            )}
            <div
                className={classNameBuilder('upload-media-container', {
                    'with-motion-params': isMotionParamsEnabled,
                })}
            >
                {!isMotionParamsEnabled ? (
                    <AspectRatioKeeper>
                        <Image
                            src={modifyExternalUrl(imageDataUrl)}
                            alt="Card media"
                            loadingComponent={<ThumbnailLoading />}
                        />
                    </AspectRatioKeeper>
                ) : (
                    <Image
                        src={modifyExternalUrl(imageDataUrl)}
                        alt="Card media"
                        loadingComponent={<ThumbnailLoading />}
                        className={classNameBuilder('uploaded-image', {
                            'with-motion-params': isMotionParamsEnabled,
                        })}
                    />
                )}

                <ThumbnailOverlay
                    onButtonClick={() => onCleanMedia()}
                    isReloadButton={false}
                    showXButton={true}
                    {...thumbnailOverlayProps}
                />
            </div>
        </div>
    );
};
